import { AfterViewInit, Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive({
  selector: '[shopFirstRenderMarker]',
  standalone: true,
})
export class ShopFirstRenderMarkerDirective implements AfterViewInit {
  @Input() shopFirstRenderMarker: string = '';
  @Output() shopFirstRenderMarkerRendered = new EventEmitter<string>();

  ngAfterViewInit(): void {
    const emitRendered = (): void => this.shopFirstRenderMarkerRendered.emit(this.shopFirstRenderMarker);
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(emitRendered);
      return;
    }
    setTimeout(emitRendered, 0);
  }
}
